/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Mixins
import action from './action';

// Components
import LoaderButton from 'shared/ui/components/form-components/LoaderButton.vue';

const ATTENDANCE_KEY = 'refresh_attendance';
const REFRESH_RATE = 60;

const __vue_script__ = {
    name: 'AttendanceStatusUpdateButton',

    components: {
        LoaderButton
    },

    mixins: [action],

    data() {
        return {
            retry: 0,
            running: false,
            remainingTimeToEnable: 0,
            ttlTimeout: null
        };
    },

    computed: {
        isDisabled() {
            return this.running || this.remainingTimeToEnable > 0;
        }
    },

    created() {
        const storedValue = localStorage.getItem(ATTENDANCE_KEY);
        if (storedValue) {
            // disable the button and show time
            const { init, ttl } = JSON.parse(storedValue);
            const timePassed = Math.floor((Date.now() - init) / 1000);

            if (timePassed >= ttl) {
                localStorage.removeItem(ATTENDANCE_KEY);
            } else {
                this.setupRestoreButton(ttl - timePassed);
            }
        }
    },

    methods: {
        async startUpdate() {
            try {
                if (this.isDisabled) {
                    return;
                }

                if (this.retry > 5) {
                    this.$notify({
                        group: 'flashes',
                        text: this.$i18n.t('general.system_error').toString(),
                        type: 'error',
                        duration: 10000
                    });
                    this.retry = 0;
                    return;
                }

                this.running = true;
                const { status, jobId, jobTTL, started } = await this.$services.pax.updateAttendance(this.event._id);

                if (status !== 'ok') {
                    throw new Error('failed to start attendance update');
                }

                localStorage.setItem(ATTENDANCE_KEY, JSON.stringify({ init: Date.now(), ttl: jobTTL }));
                this.setupRestoreButton(jobTTL);

                if (!started) {
                    // show alert with message about ttl
                    this.$modal.show('dialog', {
                        title: this.$t('listings.actions.refresh_rate_limit_title'),
                        text: this.$t('listings.actions.refresh_rate_limit', [Math.ceil(jobTTL / 60)]),
                        buttons: [
                            {
                                title: this.$t('general.dismiss'),
                                default: true,
                                class: 'btn'
                            }
                        ]
                    });
                }

                await this.$services.jobs.waitFor({ jobId });
                this.retry = 0;
            } catch (error) {
                console.error('[AttendanceStatusUpdateButton] Error updating status:', error);
                this.retry += 1;

            } finally {
                this.running = false;
            }
        },

        setupRestoreButton(time) {
            console.info('Refresh attendance will be possible again in...', time);
            this.remainingTimeToEnable = Math.max(time, 0);

            if (!this.remainingTimeToEnable) {
                clearTimeout(this.ttlTimeout);
                localStorage.removeItem(ATTENDANCE_KEY);
                return;
            }

            return setTimeout(() => {
                clearTimeout(this.ttlTimeout);
                this.ttlTimeout = this.setupRestoreButton(this.remainingTimeToEnable - REFRESH_RATE);
            }, REFRESH_RATE * 1000);
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "attendance-status-update-button" }, [
    _c(
      "div",
      {
        staticClass: "btn btn-default",
        attrs: {
          type: "button",
          status: _vm.running,
          disabled: _vm.isDisabled,
        },
        on: {
          click: function ($event) {
            return _vm.startUpdate()
          },
        },
      },
      [
        _vm.running
          ? _c("span", [
              _c("i", { staticClass: "ic-refresh-cw" }),
              _vm.running
                ? _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("listings.actions.updating_attendance_status")
                      )
                    ),
                  ])
                : _vm._e(),
            ])
          : _c("span", [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("listings.actions.update_attendance_status"))
                ),
              ]),
              _c("i", {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip.top",
                    value: {
                      boundariesElement: "body",
                      content: _vm.$t(
                        "listings.actions.update_attendance_status_tooltip"
                      ),
                    },
                    expression:
                      "{ boundariesElement: 'body', content: $t('listings.actions.update_attendance_status_tooltip')}",
                    modifiers: { top: true },
                  },
                ],
                staticClass: "tip ic-info-fill",
              }),
              _vm.isDisabled
                ? _c("span", { staticClass: "badge" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "listings.actions.update_attendance_status_time_left",
                          [Math.ceil(_vm.remainingTimeToEnable / 60)]
                        )
                      )
                    ),
                  ])
                : _vm._e(),
            ]),
      ]
    ),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/listings/custom-actions/AttendanceStatusUpdateButton.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__